import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContactUsSectionComponent } from '../../../shared/components/contact-us/contact-us.component';
import { ListComponent } from './pages/list/list.component';
import { BlogsRoutingModule } from './blogs-routing.module';
import { CardComponent } from './components/card/card.component';
import { TranslateModule } from '../../../shared/modules/translate/translate.module';
import { DetailsComponent } from './components/details/details.component';
import { ToolsJumbotronComponent } from '../../../layouts/shared/components/tools-jumbotron/tools-jumbotron.component';
@NgModule({
  declarations: [ListComponent, CardComponent, DetailsComponent],
  imports: [CommonModule, BlogsRoutingModule, TranslateModule, ToolsJumbotronComponent],
})
export class BlogsModule { }